// 引用css
import '../scss/base.scss';
import '../scss/main.scss';
// 开发引用html，热更新
if (process.env.NODE_ENV === 'development') {
  require('raw-loader!../index.html');
  require('raw-loader!../_main.html');
}
import '../lib/swiper';
import '../scss/swiper.scss';
// 兼容低版本ie
import 'es5-shim';
import 'es5-shim/es5-sham';

import * as service from './service';
import $ from 'jquery';
import { getParam } from 'utilsES';
import { init } from './main'

$(function () {
  window.activityDataLayer.push({
    eventName: "view-page",
    aid: "dlssrvtline2",
    gameId: 274
  })
  dataLayer.push({
    event: 'entrance',
    scid: getParam('scid'),
    cid: getParam('cid')
  });

  init()
});

window.addEventListener('load', () => {
  service.init();
});